module.exports = __webpack_public_path__ + "img/logo_news_edsurge@4x.99f6d0ed.png";